<template>
    <el-dropdown @command="handleLanguageChange" trigger="click">
        <span class="language-switcher">
            <i class="el-icon-lx-global"></i>
            {{ currentLanguageName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh-CN">
                <span :class="{ 'active-language': $i18n.locale === 'zh-CN' }">
                    🇨🇳 简体中文
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="en">
                <span :class="{ 'active-language': $i18n.locale === 'en' }">
                    🇺🇸 English
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="zh-TW">
                <span :class="{ 'active-language': $i18n.locale === 'zh-TW' }">
                    🇹🇼 繁體中文
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="ja">
                <span :class="{ 'active-language': $i18n.locale === 'ja' }">
                    🇯🇵 日本語
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="ko">
                <span :class="{ 'active-language': $i18n.locale === 'ko' }">
                    🇰🇷 한국어
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="ar">
                <span :class="{ 'active-language': $i18n.locale === 'ar' }">
                    🇸🇦 العربية
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="ms">
                <span :class="{ 'active-language': $i18n.locale === 'ms' }">
                    🇲🇾 Bahasa Melayu
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="fr">
                <span :class="{ 'active-language': $i18n.locale === 'fr' }">
                    🇫🇷 Français
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="de">
                <span :class="{ 'active-language': $i18n.locale === 'de' }">
                    🇩🇪 Deutsch
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="ru">
                <span :class="{ 'active-language': $i18n.locale === 'ru' }">
                    🇷🇺 Русский
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="vi">
                <span :class="{ 'active-language': $i18n.locale === 'vi' }">
                    🇻🇳 Tiếng Việt
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="th">
                <span :class="{ 'active-language': $i18n.locale === 'th' }">
                    🇹🇭 ภาษาไทย
                </span>
            </el-dropdown-item>
            <el-dropdown-item command="hi">
                <span :class="{ 'active-language': $i18n.locale === 'hi' }">
                    🇮🇳 हिन्दी
                </span>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    name: 'LanguageSwitcher',
    computed: {
        currentLanguageName() {
            const langMap = {
                'zh-CN': '简体中文',
                'en': 'English',
                'zh-TW': '繁體中文',
                'ja': '日本語',
                'ko': '한국어',
                'ar': 'العربية',
                'ms': 'Bahasa Melayu',
                'fr': 'Français',
                'de': 'Deutsch',
                'ru': 'Русский',
                'vi': 'Tiếng Việt',
                'th': 'ภาษาไทย',
                'hi': 'हिन्दी'
            };
            return langMap[this.$i18n.locale] || '简体中文';
        }
    },
    methods: {
        handleLanguageChange(lang) {
            if (this.$i18n.locale === lang) return;
            
            // 切换语言
            this.$i18n.locale = lang;
            
            // 保存到本地存储
            localStorage.setItem('language', lang);
            
            // 显示提示
            this.$message.success(this.getSuccessMessage(lang));
            
            // 可选:刷新页面以确保所有组件正确更新
            // window.location.reload();
        },
        
        getSuccessMessage(lang) {
            const messages = {
                'zh-CN': '语言已切换为简体中文',
                'en': 'Language switched to English',
                'zh-TW': '語言已切換為繁體中文',
                'ja': '言語が日本語に切り替わりました',
                'ko': '언어가 한국어로 변경되었습니다',
                'ar': 'تم تغيير اللغة إلى العربية',
                'ms': 'Bahasa telah ditukar kepada Bahasa Melayu',
                'fr': 'Langue changée en français',
                'de': 'Sprache auf Deutsch geändert',
                'ru': 'Язык изменён на русский',
                'vi': 'Đã chuyển ngôn ngữ sang tiếng Việt',
                'th': 'เปลี่ยนภาษาเป็นภาษาไทยแล้ว',
                'hi': 'भाषा हिंदी में बदली गई'
            };
            return messages[lang] || '语言已切换';
        }
    }
};
</script>

<style scoped>
.language-switcher {
    cursor: pointer;
    padding: 0 10px;
    color: #606266;
    font-size: 14px;
    display: flex;
    align-items: center;
    transition: color 0.3s;
}

.language-switcher:hover {
    color: #409eff;
}

.active-language {
    color: #409eff;
    font-weight: bold;
}

/* 下拉菜单样式优化 */
::v-deep .el-dropdown-menu__item {
    padding: 8px 20px;
}

::v-deep .el-dropdown-menu__item:hover {
    background-color: #ecf5ff;
}
</style>
